import { Component, OnInit } from '@angular/core'
import { BitsoService } from '../bitso/services/bitso.service'

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  infoCliente: any;
  constructor(private bitsoService: BitsoService) {}

  public contentHeader: object

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit() {
    this.contentHeader = {
      headerTitle: 'Home',
      actionButton: true,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'Home',
            isLink: true,
            link: '/'
          },
          {
            name: 'Sample',
            isLink: false
          }
        ]
      }
    }

    this.bitsoService.obtenerInfoCliente().subscribe({
      next: (data) => {
        this.infoCliente = data;
        console.log('Info del cliente:', data);
      },
      error: (err) => {
        console.error('Error al obtener info del cliente:', err);
      }
    });
    
  }
}
